define.alias("ember-assign-helper/helpers/assign", "calendar/helpers/assign");